import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle, Clock, Settings, Zap, FileText, BarChart3, Bell, RefreshCw, Gift, Bot, Newspaper } from 'lucide-react';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const CommunicationSettingsPage = () => {
  const navigate = useNavigate();
  
  const communicationCards = [
    {
      id: 'reminders',
      icon: Clock,
      color: 'indigo',
      title: 'Erinnerungen',
      description: 'Email & WhatsApp Terminerinnerungen',
      path: '/settings/advanced?tab=reminders'
    },
    {
      id: 'automation',
      icon: Zap,
      color: 'orange',
      title: 'Automatisierung',
      description: 'Automatische Benachrichtigungs-Regeln',
      path: '/automation/rules'
    },
    {
      id: 'reengagement',
      icon: RefreshCw,
      color: 'cyan',
      title: 'Re-Engagement',
      description: 'Inaktive Kunden erinnern & Rabattcodes',
      path: '/settings/re-engagement'
    },
    {
      id: 'push_configs',
      icon: Bell,
      color: 'yellow',
      title: 'Push-Texte',
      description: 'Termin-Erinnerungen, Inaktivität & Smart-Coach',
      path: '/push/configs'
    },
    {
      id: 'email_templates',
      icon: FileText,
      color: 'teal',
      title: 'Email Vorlagen',
      description: '9 Email-Templates bearbeiten',
      path: '/email/templates'
    },
    {
      id: 'whatsapp_templates',
      icon: FileText,
      color: 'green',
      title: 'WhatsApp Templates',
      description: 'Templates für Meta',
      path: '/whatsapp/templates'
    },
    {
      id: 'card_expiry',
      icon: Bell,
      color: 'amber',
      title: '💳 Kreditkarten-Ablauf',
      description: 'Benachrichtigungen wenn Karten ablaufen',
      path: '/settings/card-expiry'
    },
    {
      id: 'logs',
      icon: BarChart3,
      color: 'gray',
      title: 'Versand Logs',
      description: 'Email Historie',
      path: '/email/logs'
    },
    {
      id: 'birthday',
      icon: Gift,
      color: 'pink',
      title: 'Geburtstage',
      description: 'Lieferanten-Emails vor Kundengeburtstagen',
      path: '/settings/advanced?tab=birthday',
      testId: 'birthday-settings-card'
    },
    {
      id: 'newsletter',
      icon: Newspaper,
      color: 'indigo',
      title: 'Newsletter',
      description: 'Newsletter an Kunden versenden',
      path: '/settings/advanced?tab=newsletter'
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      purple: { bg: 'bg-purple-100', text: 'text-purple-600' },
      blue: { bg: 'bg-blue-100', text: 'text-blue-600' },
      indigo: { bg: 'bg-indigo-100', text: 'text-indigo-600' },
      orange: { bg: 'bg-orange-100', text: 'text-orange-600' },
      teal: { bg: 'bg-teal-100', text: 'text-teal-600' },
      green: { bg: 'bg-green-100', text: 'text-green-600' },
      yellow: { bg: 'bg-yellow-100', text: 'text-yellow-600' },
      gray: { bg: 'bg-gray-100', text: 'text-gray-600' },
      cyan: { bg: 'bg-cyan-100', text: 'text-cyan-600' },
      amber: { bg: 'bg-amber-100', text: 'text-amber-600' },
      pink: { bg: 'bg-pink-100', text: 'text-pink-600' },
    };
    return colorMap[color] || { bg: 'bg-gray-100', text: 'text-gray-600' };
  };

  return (
    <div className="p-8 max-w-6xl">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <MessageCircle className="h-6 w-6" />
          Kommunikations-Einstellungen
        </h1>
        <p className="text-gray-600 mt-1">
          Zentrale Verwaltung für Email und WhatsApp Kommunikation
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {communicationCards.map(card => {
          const Icon = card.icon;
          const colors = getColorClasses(card.color);
          return (
            <Card
              key={card.id}
              className="cursor-pointer hover:shadow-lg transition-all"
              onClick={() => navigate(card.path)}
              data-testid={card.testId}
            >
              <CardHeader>
                <CardTitle className="flex items-center gap-3">
                  <div className={`p-3 rounded-lg ${colors.bg}`}>
                    <Icon className={`h-6 w-6 ${colors.text}`} />
                  </div>
                  <span>{card.title}</span>
                </CardTitle>
                <CardDescription>{card.description}</CardDescription>
              </CardHeader>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default CommunicationSettingsPage;
